import React, { useEffect, useState } from "react";
import "./index.css";
import {
  Breadcrumb,
  Layout,
  Menu,
  Space,
  theme,
  Row,
  Col,
  Timeline,
  Card,
  Avatar,
  List,
  Typography,
  Divider,
  Empty,
  Button,
  Result,
  Image,
} from "antd";

import {
  ContractEditor,
  ContractList,

  RecipientView,

  TemplateEditor,
  TemplateList,

} from "sendforsign";

const { Text, Link, Title } = Typography;

const App: React.FC = () => {
  // Получаем параметры из URL
  const urlParams = new URLSearchParams(window.location.search);
  const apiKey = urlParams.get("apiKey") || "";
  const clientKey = urlParams.get("clientKey") || "";
  const contractKey = urlParams.get("contractKey") || "";
  const token = urlParams.get("token") || "";
  const recipientKey = urlParams.get("recipientKey") || "";

  let contractProps = {};

  const [agreementType, setAgreementType] = useState("any agreement");
  const [fade, setFade] = useState(false);
  const agreementOptions = ["NDA", "Invoice", "Lease", "Anything"];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setAgreementType((prev) => {
          const currentIndex = agreementOptions.indexOf(prev);
          const nextIndex = (currentIndex + 1) % agreementOptions.length;
          return agreementOptions[nextIndex];
        });
        setFade(true); // Start fade in
      }, 300); // Match this duration with the CSS transition duration
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Row style={{ background: "#fafafa", minHeight: "100vh" }}>
      <Col flex={"auto"}></Col>
      <Col flex="1200px">
        <Space
          direction="vertical"

          style={{ display: "flex", margin: 10 }}
        >
          <Card>
            <Row>
              <Col>
                <Image
                  width={140} // Set the width for the collapsed state
                  preview={false}
                  src="https://mintlify.s3-us-west-1.amazonaws.com/sendforsign/logo/light.svg"
                />
              </Col>
              <Col flex={"auto"}></Col>
              <Col>
                <Button
                  type="default"
                  href="https://app.sendforsign.com/"
                  target="_blank"
                >
                  Login
                </Button>
              </Col>
            </Row>
          </Card>
          
          {token && contractKey ? (
            <ContractEditor
              token={token}
              contractKey={contractKey}
            />
          ) : apiKey && clientKey && contractKey ? (
            <ContractEditor
              apiKey={apiKey}
              clientKey={clientKey}
              contractKey={contractKey}
            />
          ) : (
            <Result status="403" title="No access" subTitle="Missing parameters" />
          )} 
          
          {/* <Divider /> */}

          {/* {recipientKey ? (
            <RecipientView
              recipientKey={recipientKey}
            />
          ): (
            <Result status="403" title="No access" subTitle="Missing parameters" />
          )} */}

          
          
          <Card>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Space direction="vertical" align="center">
                <Text type="secondary" style={{ textAlign: "center" }}>
                  By using Sendforsign, you agree to{" "}
                  <Link
                    href="https://about.sendforsign.com/about/termsandconditions"
                    target="_blank"
                  >
                    Terms and Conditions
                  </Link>{" "}
                  and{" "}
                  <Link
                    href="https://about.sendforsign.com/about/privacypolicy"
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>
                </Text>
                <Text type="secondary">
                  <br></br>Powered by{" "}
                  <Link href="https://sendforsign.com" target="_blank">
                    sendforsign.com
                  </Link>
                </Text>
              </Space>
            </div>
          </Card>
        </Space>
      </Col>
      <Col flex={"auto"}></Col>
    </Row>
  );
};

export default App;
